import React from "react";
import { View } from "react-native";
import { useRef } from "react";
import ReactHlsPlayer from "react-hls-player";

const Video = ({
  source = { uri: "" },
  style,
  ref,
  autoPlay = false,
  ...props
}) => {
  const { uri } = source;

  const playerRef = useRef(null);

  if (!uri) return null;

  return (
    <View style={style}>
      <ReactHlsPlayer
        {...props}
        style={{ borderRadius: 4 }}
        playerRef={playerRef}
        autoPlay={autoPlay}
        controls
        src={uri}
        hlsConfig={{
          controls: true,
        }}
      />
    </View>
  );
};

export default Video;
